import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiGetDalliDeliverySetupResponseSuccess,
    type OpenApiGetPecomDeliverySetupResponseSuccess,
    type OpenApiGetRussianPostDeliverySetupResponseSuccess,
    type OpenApiSetupDalliDeliveryRequest,
    type OpenApiSetupPecomDeliveryRequest,
    type OpenApiSetupRussianPostDeliveryRequest,
} from '#shared/api/schema';

const api = createApi({
    name: 'entities/integration/api/metashipApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            setupDalliAdd: builder.mutation<{}, OpenApiSetupDalliDeliveryRequest>({
                query: (payload) => {
                    return {
                        url: '/integrations/delivery/metaship/dalli/setup',
                        method: 'POST',
                        body: payload,
                    };
                },
            }),
            setupDalliGet: builder.query<OpenApiGetDalliDeliverySetupResponseSuccess, void>({
                query: () => {
                    return {
                        url: '/integrations/delivery/metaship/dalli/setup',
                        method: 'GET',
                    };
                },
            }),
            setupRussianPostAdd: builder.mutation<{}, OpenApiSetupRussianPostDeliveryRequest>({
                query: (payload) => {
                    return {
                        url: '/integrations/delivery/metaship/russian_post/setup',
                        method: 'POST',
                        body: payload,
                    };
                },
            }),
            setupRussianPostGet: builder.query<OpenApiGetRussianPostDeliverySetupResponseSuccess, void>({
                query: () => {
                    return {
                        url: '/integrations/delivery/metaship/russian_post/setup',
                        method: 'GET',
                    };
                },
            }),
            setupPecomAdd: builder.mutation<{}, OpenApiSetupPecomDeliveryRequest>({
                query: (payload) => {
                    return {
                        url: '/integrations/delivery/metaship/pecom/setup',
                        method: 'POST',
                        body: payload,
                    };
                },
            }),
            setupPecomGet: builder.query<OpenApiGetPecomDeliverySetupResponseSuccess, void>({
                query: () => {
                    return {
                        url: '/integrations/delivery/metaship/pecom/setup',
                        method: 'GET',
                    };
                },
            }),
        };
    },
});

export const integrationMetashipSetupDalliAdd = api.endpoints.setupDalliAdd.mutate;
export const integrationMetashipSetupRussianPostAdd = api.endpoints.setupRussianPostAdd.mutate;
export const integrationMetashipSetupPecomAdd = api.endpoints.setupPecomAdd.mutate;

export const useLazyIntegrationMetashipSetupDalli = api.useLazySetupDalliGetQuery;
export const useLazyIntegrationMetashipSetupRussianPost = api.useLazySetupRussianPostGetQuery;
export const useLazyIntegrationMetashipPecom = api.useLazySetupPecomGetQuery;
